// extracted by css-extract-rspack-plugin
export default {"forceGrayBackground":"src-wab-client-components-CopilotMsg-module__forceGrayBackground-7AfQZp"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"forceGrayBackground\":\"src-wab-client-components-CopilotMsg-module__forceGrayBackground-7AfQZp\"}";
        // 1793541993709
        var cssReload = require("../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  